<script setup lang='ts'>
    import ModalBase from '@/shared/components/ModalBase.vue';
    import { useAccessPolicyStore } from '@/stores/accessPolicyStore.ts';
    import { computed, onMounted, Ref, ref } from 'vue';
    import { PolicyRole } from '@/shared/helpers/api.ts';

    const store = useAccessPolicyStore();

    const emits = defineEmits<{
        onCancel: [void];
        onSave: [value: PolicyRole];
    }>();

    const selectedSystem: Ref<string | undefined> = ref(undefined);
    const roleName: Ref<string | undefined> = ref(undefined);
    const externalName: Ref<string | undefined> = ref(undefined);
    const description: Ref<string | undefined> = ref(undefined);

    const isFormValid = computed(() => {
        if (selectedSystem.value !== undefined && roleName.value !== undefined) {
            return selectedSystem.value.trim().length > 0
                && roleName.value.trim().length > 0;
        }
        return false;
    });

    onMounted(() => {
        if (store.selectedSystem !== undefined) {
            selectedSystem.value = store.selectedSystem.name;
        }
    });

    const onClose = () => emits('onCancel');

    function onClickSubmit() {
        if (selectedSystem.value !== undefined && roleName.value !== undefined) {
            const newPolicyRole: PolicyRole = {
                systemName: selectedSystem.value,
                name: roleName.value,
                externalName: externalName.value ?? '',
                description: description.value ?? ''
            };
            emits('onSave', newPolicyRole);
        }
    }
</script>

<template>
    <modal-base @onCancel="onClose">
        <template
            #modal-header>
            Add new roles
        </template>
        <template
            #modal-body>
            <b-field
                horizontal
                label="System"
                expanded>
                <b-autocomplete
                    v-model="selectedSystem"
                    aria-role="list"
                    :append-to-body="true"
                    placeholder="Select System"
                    open-on-focus
                    clearable
                    :data="store.policySystems.map(s => s.name)"
                    @select="(systemName: string) => selectedSystem = systemName" />
            </b-field>
            <b-field
                horizontal
                label="Role Name"
                expanded>
                <b-input
                    v-model="roleName" />
            </b-field>
            <b-field
                horizontal
                label="External Name">
                <b-input v-model="externalName" />
            </b-field>
            <b-field
                horizontal
                label="Description">
                <b-input v-model="description" />
            </b-field>
        </template>
        <template #modal-footer>
            <b-field
                grouped
                position="right">
                <b-button
                    label="Cancel"
                    @click="onClose" />
                <b-button
                    label="Add"
                    :disabled="!isFormValid"
                    type="is-primary"
                    @click="onClickSubmit" />
            </b-field>
        </template>
    </modal-base>
</template>

<style scoped>

</style>
